"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var questions = [{
  prompt: "Can you write down your own personal thought that causes you to distract or procrastinate?",
  type: "textarea",
  meta: {
    answerLabel: "The personal thought that causes me to distract or procrastinate:",
    summaryTitle: "The personal thought that causes me to distract or procrastinate:"
  },
  batteryId: "RETRAINING_THINKING_FOCUS"
}, {
  prompt: "What will be the impact on your self-esteem if you were to never master procrastination?",
  type: "textarea",
  meta: {
    answerLabel: "The impact on my self-esteem if I were to never master procrastination:",
    summaryTitle: "The impact on my self-esteem if I were to never master procrastination:"
  },
  batteryId: "RETRAINING_THINKING_FOCUS"
}, {
  prompt: "And what would the impact be on your career or education?",
  type: "textarea",
  meta: {
    answerLabel: "The impact be on my career or education:",
    summaryTitle: "The impact be on my career or education:"
  },
  batteryId: "RETRAINING_THINKING_FOCUS"
}, {
  prompt: "How about your finances and wealth?",
  type: "textarea",
  meta: {
    answerLabel: "The impact be on finances and wealth:",
    summaryTitle: "The impact be on finances and wealth:"
  },
  batteryId: "RETRAINING_THINKING_FOCUS"
}, {
  prompt: "When you feel like procrastinating, do you know what the feeling is that you are trying to avoid or distract yourself from?",
  type: "multiWithOther",
  meta: {
    answerLabel: "The feeling im trying to avoid is:",
    summaryTitle: "The feeling I am trying to avoid when i procrastinate is:"
  },
  options: ["Boredom", "Not feeling smart enough", "Overwhelmed by the task", "Pressure to succeed", "Other"],
  batteryId: "RETRAINING_THINKING_FOCUS"
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;